import React, { useCallback, useState } from 'react';
import {
  CheckIcon,
  ContainerPaymentAdvance,
  ContentPaymentAdvance,
  CustomToggle,
  FixedDropdownMenu,
  HeaderPaymentAdvance,
  MethodsPaymentAdvance,
  PaymentsAdvance,
  TextMethodAdvance,
  TextMethodSummary,
  TextPaymentAdd,
  TextSummary,
} from './styles';
import {
  IconCheckCircle,
  IconChevronDown,
  Button as TakeatButton,
  Input as TakeatInput,
  IconMoneyCircle,
  IconTrash,
} from 'takeat-design-system-ui-kit';
import { Dropdown, DropdownItem } from 'reactstrap';
import { useCart } from 'context/OrderingSystem/Cart';
import api2 from 'services/api2';
import toast from 'react-hot-toast';

export const AdvancePayment = ({
  paymentMethods,
  infosPaymentsAdvance,
  setinfosPaymentAdvance,
  taxUser,
}) => {
  const { cart } = useCart();
  const [paymentAdvanceOpen, setPaymentAdvanceOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDrop = () => setDropdownOpen((prevState) => !prevState);
  const [currentValueAdvance, setCurrentValueAdvance] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedMethodId, setSelectedMethodId] = useState([]);
  const { priceCombo, priceProducts } = cart.reduce(
    (acc, item) => {
      if (item.combo_price !== undefined) {
        acc.priceCombo += item.combo_price * item.amount;
      } else {
        acc.priceProducts += item.price * item.amount;
      }
      return acc;
    },
    { priceCombo: 0, priceProducts: 0 }
  );

  const total = priceCombo + priceProducts;

  const totalPartial = infosPaymentsAdvance.reduce(
    (sum, py) => sum + py.value,
    0
  );
  const valuePercentage = (totalPartial / total).toFixed(2) * 100;
  const [paymentAdvanceClick, setPaymentAdvanceClick] = useState(false);
  const [isLoadingButton, setIsLoadingButton] = useState(false);

  const verifyOpeningBox = useCallback(async () => {
    try {
      await api2.get('/restaurants/cashier-opening-verify');
    } catch (err) {
      if (err.response.data.errorType === 'cashier_opening_not_found') {
        toast.error('Você precisa abrir seu caixa para inserir pagamentos!');
        setIsLoadingButton(false);
        return false;
      } else {
        toast.error('Erro ao carregar valores totais');
        setIsLoadingButton(false);
      }
    }
  }, []);

  return (
    <ContainerPaymentAdvance>
      <HeaderPaymentAdvance
        onClick={() => {
          setPaymentAdvanceOpen(!paymentAdvanceOpen);
        }}
      >
        <TextPaymentAdd>Adicionar pagamento antecipado</TextPaymentAdd>
        <IconChevronDown
          fontSize={24}
          style={{
            transform: `rotate(${paymentAdvanceOpen ? '-180deg' : '0deg'})`,
            transition: 'transform 0.3s ease',
            cursor: 'pointer',
          }}
        />
      </HeaderPaymentAdvance>
      <ContentPaymentAdvance $open={paymentAdvanceOpen}>
        <>
          <TakeatInput
            label="Valor a ser pago"
            placeholder="R$"
            isCurrency
            value={currentValueAdvance}
            style={{
              background: 'var(--Takeat-Colors-Neutrals-White, #fff)',
            }}
            onChange={(e) => {
              const inputValue = Number(e.target.value);
              const maxValue = Number(total + taxUser).toFixed(2);

              if (inputValue > maxValue) {
                setCurrentValueAdvance('');
                toast.error(
                  'Valor antecipado deve ser menor que o valor total'
                );
                return;
              }
              setCurrentValueAdvance(inputValue);
            }}
          />
          <PaymentsAdvance>
            {paymentMethods.slice(0, 8).map((method, index) => (
              <MethodsPaymentAdvance
                isSelected={selectedMethod === method.label}
                key={index}
                style={{ width: '100%' }}
                onClick={() => {
                  setSelectedMethod(method.label);
                  setSelectedMethodId(method.value);
                }}
              >
                <TextMethodAdvance>{method.label}</TextMethodAdvance>
                {selectedMethod === method.label && (
                  <CheckIcon>
                    <IconCheckCircle />
                  </CheckIcon>
                )}
              </MethodsPaymentAdvance>
            ))}

            {paymentMethods.length > 8 && (
              <Dropdown isOpen={dropdownOpen} size="sm" toggle={toggleDrop}>
                <CustomToggle
                  isSelected={paymentMethods
                    .slice(8)
                    .some((m) => m.label === selectedMethod)}
                  caret
                  className="custom-toggle"
                >
                  <TextMethodAdvance>
                    {selectedMethod &&
                    paymentMethods
                      .slice(8)
                      .some((m) => m.label === selectedMethod)
                      ? selectedMethod
                      : 'Outros'}
                  </TextMethodAdvance>
                </CustomToggle>

                <FixedDropdownMenu className="fixed-box">
                  {paymentMethods.slice(8).map((method, index) => (
                    <DropdownItem
                      key={index}
                      onClick={() => {
                        setSelectedMethod(method.label);
                        setSelectedMethodId(method.value);
                      }}
                    >
                      {method.label}
                      {selectedMethod === method.label && (
                        <CheckIcon>
                          <IconCheckCircle />
                        </CheckIcon>
                      )}
                    </DropdownItem>
                  ))}
                </FixedDropdownMenu>
              </Dropdown>
            )}
          </PaymentsAdvance>
          <TakeatButton
            iconLeft={<IconMoneyCircle />}
            isLoading={isLoadingButton}
            style={{ width: '100%' }}
            customColor={'#27A84C'}
            disabled={
              !selectedMethod ||
              !currentValueAdvance ||
              Number(currentValueAdvance) <= 0 ||
              cart.length === 0
            }
            onClick={async () => {
              setIsLoadingButton(true);
              const paymentData = {
                method: selectedMethod,
                id: selectedMethodId,
                value: Number(currentValueAdvance),
                date: new Date().toISOString(),
              };

              const canContinue = await verifyOpeningBox();

              if (canContinue === false) {
                return;
              }

              setinfosPaymentAdvance((prev) => [...prev, paymentData]);

              setSelectedMethod(null);
              setCurrentValueAdvance('');
              setPaymentAdvanceClick(true);
              setIsLoadingButton(false);
            }}
          >
            $ Adicionar pagamento
          </TakeatButton>
        </>
        {paymentAdvanceClick && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '3px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <TextSummary>Total do pedido:</TextSummary>
              <TextSummary>
                R$ {Number(total).toFixed(2).replace('.', ',')}
              </TextSummary>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <TextSummary>Taxa de entrega</TextSummary>
              <TextSummary>
                {Number(taxUser).toFixed(2).replace('.', ',')}
              </TextSummary>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <TextSummary>Pagamento antecipado:</TextSummary>
              <TextSummary>
                {Number(valuePercentage).toFixed(2).replace('.', ',')}%
              </TextSummary>
            </div>
            {infosPaymentsAdvance.map((py, index) => {
              const name = py.method;
              const date = py.date
                ? new Date(py.date)
                    .toLocaleString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                    .replace(',', '-')
                : '-';

              return (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <TextMethodSummary>{`${name} - ${date}`}</TextMethodSummary>
                  <TextMethodSummary $total>
                    {' '}
                    R$ {Number(py.value).toFixed(2).replace('.', ',')}
                    <IconTrash
                      style={{ cursor: 'pointer', marginLeft: '8px' }}
                      fill={'#C8131B'}
                      fontSize={20}
                      onClick={() => {
                        setinfosPaymentAdvance((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                      }}
                    />
                  </TextMethodSummary>
                </div>
              );
            })}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <TextSummary $total>Total</TextSummary>
              <TextSummary>
                R${' '}
                {Number(total + taxUser)
                  .toFixed(2)
                  .replace('.', ',')}
              </TextSummary>
            </div>
          </div>
        )}
      </ContentPaymentAdvance>
    </ContainerPaymentAdvance>
  );
};
